import { types, actions } from './requests'
export const CREATEINTERVAL_TYPES = {
    ...types('CREATEINTERVAL'),
}
export const CREATEINTERVAL_ACTIONS = {
    ...actions('CREATEINTERVAL'),
}